import { render } from "./LiveAssistant.vue?vue&type=template&id=ca514e60&scoped=true"
import script from "./LiveAssistant.vue?vue&type=script&lang=js"
export * from "./LiveAssistant.vue?vue&type=script&lang=js"

import "./LiveAssistant.vue?vue&type=style&index=0&id=ca514e60&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca514e60"]])

export default __exports__